import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductVariant } from '../data/product';

/** Create / Filter shapes are local — ProductVariant lives in product.ts. */
export type ProductVariantCreate = Omit<
  ProductVariant,
  'productVariantId' | 'tenantId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy' | 'deletedAt' | 'deletedBy'
>;
export type ProductVariantFilter = Partial<
  Pick<ProductVariant, 'productVariantId' | 'productId' | 'storeId' | 'sku' | 'barcode' | 'isActive'>
>;

export function createProductVariantService(client: AxiosInstance) {
  return createCrudService<ProductVariant, ProductVariantCreate, ProductVariantFilter>(
    client,
    '/ProductVariant',
    'productVariantId'
  );
}

export type ProductVariantService = CrudService<
  ProductVariant,
  ProductVariantCreate,
  ProductVariantFilter
>;
